module.exports = __webpack_public_path__ + "img/brushes-en-6.7f63838.jpg";